import { useState } from 'react';
import ModalCloseButton from './ModalCloseButton';

const InvitePlayersModal = ({
  clubName,
  joinCode,
  playerFirstName,
  allPlayers = [],
  onAddGuest,
  onClose,
}) => {
  const [isSharing, setIsSharing] = useState(false);
  const [isAddingGuest, setIsAddingGuest] = useState(false);
  const [guestName, setGuestName] = useState('');
  const [guestError, setGuestError] = useState('');
  const [isSubmittingGuest, setIsSubmittingGuest] = useState(false);

  const inviteMessage = `${playerFirstName} wants you to join ${clubName} on Padel MVP.\n\nhttp://padelmvp.co.uk\n\nJoin code: ${joinCode}`;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        setIsSharing(true);
        await navigator.share({
          title: `Join ${clubName} on Padel MVP`,
          text: inviteMessage,
        });
        onClose();
      } catch (error) {
        // User cancelled or error occurred
        if (error.name !== 'AbortError') {
          console.error('Error sharing:', error);
        }
      } finally {
        setIsSharing(false);
      }
    } else {
      // Fallback: copy to clipboard
      try {
        await navigator.clipboard.writeText(inviteMessage);
        alert('Invite message copied to clipboard!');
        onClose();
      } catch (error) {
        console.error('Error copying to clipboard:', error);
        alert('Unable to share. Please copy the message manually.');
      }
    }
  };

  const handleAddGuestSubmit = async (e) => {
    e?.preventDefault?.();
    const trimmed = guestName.trim();
    if (!trimmed) {
      setGuestError('Please enter a name for the guest.');
      return;
    }
    const alreadyExists = (allPlayers || []).some(
      (p) => (p?.name || '').trim().toLowerCase() === trimmed.toLowerCase()
    );
    if (alreadyExists) {
      setGuestError('A player with this name already exists in this club.');
      return;
    }

    try {
      setIsSubmittingGuest(true);
      setGuestError('');
      if (onAddGuest) {
        await onAddGuest(trimmed);
      }
      onClose();
    } catch (err) {
      console.error('Error adding guest player:', err);
      setGuestError('Failed to add guest player. Please try again.');
    } finally {
      setIsSubmittingGuest(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <ModalCloseButton onClick={onClose} />

        {isAddingGuest ? (
          /* ADD GUEST PLAYER FORM */
          <>
            <h3 className="modal-title">
              Add Guest
            </h3>

            <form onSubmit={handleAddGuestSubmit} className="modal-content">
              <p className="modal-text" style={{ marginBottom: 16 }}>
                Guest players can be added to matches and have stats tracked, but are not connected to a login account.
              </p>

              {guestError && (
                <p className="text-red-400 text-sm mb-md font-bold">{guestError}</p>
              )}

              <div>
                <input
                  type="text"
                  placeholder="Guest name"
                  value={guestName}
                  onChange={(e) => {
                    setGuestName(e.target.value);
                    setGuestError('');
                  }}
                  className="input w-full"
                  autoFocus
                />
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  onClick={() => {
                    setIsAddingGuest(false);
                    setGuestName('');
                    setGuestError('');
                  }}
                  className="btn btn-secondary"
                >
                  <span className="btn-text">BACK</span>
                </button>

                <button
                  type="submit"
                  disabled={!guestName.trim() || isSubmittingGuest}
                  className="btn btn-primary"
                >
                  <span className="btn-text">
                    {isSubmittingGuest ? 'ADDING...' : 'ADD GUEST'}
                  </span>
                </button>
              </div>
            </form>
          </>
        ) : (
          /* STANDARD INVITE / SHARE VIEW */
          <>
            <h3 className="modal-title">
              Invite Players
            </h3>

            <div className="modal-content">
              <div className="card-content body" style={{ 
                whiteSpace: 'pre-line', 
                padding: 'var(--spacing-md)',
                backgroundColor: 'var(--surface-container-dark)',
                borderRadius: 'var(--radius-md)',
                marginBottom: 'var(--spacing-lg)'
              }}>
                {inviteMessage}
              </div>

              <div className="modal-actions">
                <button
                  onClick={handleShare}
                  disabled={isSharing}
                  className="btn btn-primary btn-full"
                >
                  <span className="btn-text">
                    {isSharing ? 'SHARING...' : 'SHARE'}
                  </span>
                </button>

                <button
                  type="button"
                  onClick={() => {
                    setIsAddingGuest(true);
                    setGuestError('');
                  }}
                  className="btn btn-secondary btn-full"
                >
                  <span className="btn-text">
                    ADD GUEST
                  </span>
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default InvitePlayersModal;


